document.addEventListener('DOMContentLoaded', function () {
  // Get the registration form
  var form = document.getElementById('create_customer'); // Make sure this ID matches your registration form ID

  if (form) {
    // Add asterisk (*) next to the label of required fields
    var requiredFields = form.querySelectorAll('input[required], select[required], textarea[required], input[type="checkbox"][required]');
    
    requiredFields.forEach(function(field) {
      var label = form.querySelector(`label[for="${field.id}"]`);
      if (label) {
        // Check if the label already has an asterisk to prevent adding it twice
        if (!label.querySelector('.required')) {
          var requiredSpan = document.createElement('span');
          requiredSpan.className = 'required';
          requiredSpan.textContent = ' *'; // Add the asterisk
          label.appendChild(requiredSpan);
        }
      }
    });

    form.addEventListener('submit', function (event) {
      var fields = form.querySelectorAll('input[required], select[required], textarea[required]');
      var valid = true;

      // Loop through all required fields and check if they are filled
      fields.forEach(function (field) {
        // Handle the checkbox separately
        if (field.type === 'checkbox') {
          if (!field.checked) {
          //  field.style.borderColor = 'red';  // Highlight empty checkbox
          //  valid = false;
          } else {
           // field.style.borderColor = '';  // Reset border color for valid checkbox
          }
        } else {
          // Regular validation for text fields, etc.
          if (!field.value.trim()) {
            field.style.borderColor = 'red';  // Highlight empty fields
            valid = false;
          } else {
            field.style.borderColor = '';  // Reset border color for valid fields
          }
        }
      });

      // If there are invalid fields, prevent form submission
      if (!valid) {
        event.preventDefault();  // Prevent form submission
        event.stopImmediatePropagation();  // Ensure no further event listeners get triggered
        alert('Please fill out all required fields.');  // Display alert for missing fields
        return false;  // Explicitly return false to stop form submission
      }
    });
  }
});
